export function getItem(baseProduct, sizeSku, sizeSelectionLabel, withPrice, quantity, internationalSizes) {
    if (!baseProduct) return null;

    const { productInfo, category, attributes, price } = baseProduct;
    const { productID, productName, manufacturer, manufacturerID, gender } = productInfo;

    const { firstVisibleDate, productStock = [], preOrderFlag = false, badges = [], sustainabilityFlag, saleFlag } = attributes || {};
    const sku = productStock.find((sku) => sku.size === sizeSelectionLabel);

    return [
        {
            productInfo: {
                productID,
                productName,
                manufacturer,
                manufacturerID,
                ...(sizeSku && { sku: sizeSku, size: sizeSelectionLabel, sizeInfo: parseSizeInfo(internationalSizes) }),
                ...(gender && { gender }),
            },
            category,
            ...(quantity && { quantity }),
            attributes: {
                firstVisibleDate,
                preOrderFlag,
                ...(sku ? { stock: sku.stock } : {}),
                badges,
                sustainabilityFlag,
                saleFlag,
            },
            ...(withPrice && { price: price }),
        },
    ];
}

export function parseSizeInfo(internationalSizes) {
    if (!internationalSizes) return null;

    return internationalSizes.reduce((acc, size) => {
        acc[size.name] = size.labels[0];
        return acc;
    }, {});
}
